import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Alert, Container } from "react-bootstrap";
import T from "../../common/traducao";
import NewAlertError from "../../components/ui_comp/Alerts/views.alert.error";
import PedidosListCards from "./pedidos.list.cards";
import { PedidosSearchView } from "./pedidos.searchview";
import pedidoService from "../../services/service.pedido";
import { PedidosFilterSituacao } from "./pedidos.filter.situacao";
import jwt_token from "jwt-decode";
import ModalImprimir from "../../components/ui_comp/Modals/ModalPrintOut";
import { SituacaoPedido, SituacaoAnaliseTecnica, getStyleFiltroPedido } from "../../consts/situacao_pedido";
import {
    getFiltro,
    GetPermissaoVisualizar,
    getToken,
} from "../../config/localstorageConfig/localstorage";
import ImprimirPedido from "../../components/ui_comp/Modals/ModalPrintOut/ImprimirPedidoControl";
import { useNavigate } from "react-router-dom";


export const PedidoVendaList = () => {

    const constantes = T();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [permiteVisualizar, setPermiteVisualizar] = useState(false);
    const [permiteConsultarStatus, setPermiteConsultarStatus] = useState(false);
    const [error, setError] = useState();

    const [pedidos, setPedidos] = useState()
    const [pages, setPages] = useState();
    const [records, setRecords] = useState();
    const [filterState, setFilterState] = useState();
    const [modalImprimir, setModalImprimir] = useState(false);
    const [IndexImprimirPedido, setIndexImprimirPedido] = useState();

    const ordertype = useRef();
    const orderField = useRef();

    function getIdPedido(index) {
        return pedidos && pedidos[index]?.Id;
    }

    function getSituacaoPedido(index) {
        return pedidos && pedidos[index]?.Situacao;
    }


    
    function GetSavedFilter() {
        const filtro = getFiltro("PEDIDOS");
        return filtro;
    }

    function OrderChange(field, type) {
        orderField.current = field;
        ordertype.current = type;

        const filter = {
            ...filterState,
            campoorder: field,
            tipoorder: type,
        };
        getPedidos(filter);
    }

     useEffect(() => {
            const token_salvo = getToken();
            if (token_salvo) {
                const token = jwt_token(token_salvo);
                setPermiteConsultarStatus(true);

                const filter = GetSavedFilter() ?? {
                    situacao: "Rascunho",
                    campo: null,
                    operacao: null,
                    valor: null,
                };
                orderField.current = filter.campoorder;
                ordertype.current = filter.tipoorder;
                getPedidos(filter);
            
                setPermiteVisualizar(GetPermissaoVisualizar("pedidosvenda"));
            } else {
                navigate('/logout');
            }
        }, []);

        function getPedidos(filter) {
            setLoading(true);
            pedidoService
                .ListVendedor(filter)
                .then((response) => {
                    setPedidos(response.data.value);
                    setPages(response.data.pages);
                    setRecords(response.data.registros);
                    setFilterState(filter);
                })
                .catch((error) => {
                    const _error =
                        error.code === "ERR_NETWORK"
                            ? "Server OffLine"
                            : error.response && error.response.data && error.response.data.error
                                ? error.response.data.error.message
                                : error.message;
                    setError(_error);

                    error.code === "ERR_NETWORK" && navigate("/logout");

                })
                .finally(() => {
                    setLoading(false);
                });
        }    

        function onPageSelect(number) {
            const filter = {
                ...filterState,
                page : number
            }
            getPedidos(filter);
        }

        const btns = [
            {
                text: "Imprimir",
                onClick: (index) => {
                    setIndexImprimirPedido(index);
                    setModalImprimir(true);
                },
            }
        ];

    return permiteVisualizar ? (
        <Container fluid className="my-3" style={{ overflowX: "hidden" }}>
            <NewAlertError error={error} onClose={() => setError(null)} />

            <ModalImprimir
                constantes={constantes}
                open={modalImprimir}
                close={() => {
                    setModalImprimir(false);
                }}
            >
                <ImprimirPedido id={getIdPedido(IndexImprimirPedido)} situacao={getSituacaoPedido(IndexImprimirPedido)} />
            </ModalImprimir>

            <Container fluid className="my-3">
                <PedidosSearchView 
                    getPedidos={getPedidos}
                    constantes={constantes}
                    permiteVisualizar={permiteVisualizar}
                    loading={loading}
                    setFilterState={setFilterState}
                />
            </Container>
            <Container fluid className="my-3">
                {permiteConsultarStatus && 
                    <PedidosFilterSituacao
                        onGetStyle={getStyleFiltroPedido}
                        constantes={constantes}
                        loading={loading}
                        onClick={
                            (event) => {

                                const attr_situacao = event.target.attributes.situacao.value;

                                let situacao = null;
                                let filters = null;
                                
                                if (attr_situacao === SituacaoPedido.BLOQUEADO_COMERCIAL) {
                                    situacao = SituacaoPedido.BLOQUEADO;
                                    filters = `situacaoComercial eq '${SituacaoPedido.BLOQUEADO}'`;
                                } else if (attr_situacao === SituacaoPedido.BLOQUEADO_FINANCEIRO) {
                                    situacao = SituacaoPedido.BLOQUEADO;
                                    filters = `situacaoFinanceira eq '${SituacaoPedido.BLOQUEADO}'`;
                                } else if (attr_situacao === SituacaoPedido.BLOQUEADO_TECNICO) {
                                    situacao = SituacaoPedido.BLOQUEADO; 
                                    filters = `SituacaoAnaliseTecnica eq '${SituacaoAnaliseTecnica.PENDENTE}' or SituacaoAnaliseTecnica eq '${SituacaoAnaliseTecnica.BLOQUEADA}'`;
                                } else {
                                    situacao = attr_situacao;
                                }

                                // Validação de segurança final antes de enviar
                                if (situacao && situacao.length > 10) {
                                    console.warn(`Atenção: Situação '${situacao}' muito longa. Encurtando...`);
                                    situacao = situacao.substring(0, 10);
                                }

                                const filter = {
                                    situacao: situacao,
                                    filters: filters,
                                    campoorder: orderField.current,
                                    tipoorder: ordertype.current,
                                };

                                getPedidos(filter);
                            }}
                    />
                }
            </Container>
            <Container fluid className="my-3">
                <PedidosListCards
                    constantes={constantes}
                    onPageSelect={onPageSelect}
                    orderField={orderField}
                    ordertype={ordertype}
                    pedidos={pedidos}
                    pages={pages}
                    records={records}
                    onGetStyle={getStyleFiltroPedido}
                    onOrderChange={OrderChange}
                    setModalImprimir={setModalImprimir}
                    setIndexImprimir={setIndexImprimirPedido}
                    buttons={btns}
                    btntype={"dropdown"}
                />            
            </Container>
        </Container>
    ) : (
        <>
            <Container>
                <Alert variant="danger">
                    <Alert.Heading>{constantes.Permissao}</Alert.Heading>
                    <p>{constantes.Msgsempermissao}</p>
                </Alert>
            </Container>
        </>
    );
}

